// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6066) return "static/chunks/6066-aded59a8975bcee8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2289":"2c677abca7eee886","6745":"3af2a3501a7a4783","9880":"6c1625de9bf53e73"}[chunkId] + ".js";
};